module.exports = __webpack_public_path__ + "static/img/logo.7e6fcbd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/logo.png
// module id = Z2Ou
// module chunks = 1